import React, { useState } from "react";
import { useDispatch } from "react-redux";
import LoginImage from "../../assets/images/MM_Login_Image.webp"
import { v4 } from 'uuid';
import { ShowToastMessage } from "../../redux/actions/AppCommonActions";
import { UserAuthApi } from "../../redux/api/UserApis"
import "./LoginPage.css";

const LoginPage = () => {
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isNumberError, setIsNumberError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [loginToast, setLoginToast] = useState(false);
    const togglePassword = () => setShowPassword((prev) => !prev);
    const validateEmail = (email) => {
        // Regular expression for email validation
        const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };
    const handleLogin = (e) => {
        e.preventDefault();
        setIsNumberError(false);

        // login logic here
        console.log({ email, password });
        if (password.length != 0 && email.length != 0 && validateEmail(email)) {
            setIsLoading(true);
            signin();
        } else {
            setIsNumberError(true);
        }
    };
    const signin = async () => {
        const deviceID = v4();
        let userLoginRes = await UserAuthApi({
            "email": email,
            "password": password,
            "deviceID": deviceID,
            "lat": "",
            "lag": ""
        })
        // setIsLoading(false);
        if (userLoginRes.status) {
            console.log("userLoginRes", userLoginRes);
            console.log("deviceID", deviceID);
            // console.log(ShowToastMessage);

            const tokenData = `Bearer ${userLoginRes.data[0].token}`;
            const userid = userLoginRes.data[0].userid;
            localStorage.setItem("token", tokenData);
            localStorage.setItem("userid", userid);
            localStorage.setItem("deviceID", deviceID);
            setLoginToast(true);
            // dispatch(ShowToastMessage('Login successfully'));
            setTimeout(function () {
                window.location.href = '/';
            }, 2000);
            setIsLoading(false);
        } else {
            // console.log("mmmmmm", userLoginRes?.errorMessage)ss
            dispatch(ShowToastMessage(userLoginRes?.message || userLoginRes?.errorMessage));
            setIsLoading(false);
        }


    };

    return (
        <div className="loginContainer">
            <div className="login-left">
                <div className="loginWrapper">
                    <h2>Login</h2>
                    <form onSubmit={handleLogin} className="login-form">
                        <div className="email-wrapper">
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter the Email ID"
                            />
                        </div>

                        <div className="password-wrapper">
                            <input
                                type={showPassword ? "text" : "password"}
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter the Password"
                            />
                        </div>
                        <div className="show-password-wrapper">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={showPassword}
                                    onChange={togglePassword}
                                    style={{ marginRight: "8px" }}
                                />
                                Show Password
                            </label>
                        </div>
                        {isNumberError && (
                            <div className="login-number-error">
                                Please enter the valid email and password
                            </div>
                        )}
                        <button type="submit">
                            {isLoading ? <div className="spinner"></div> : "Log in"}
                        </button>
                    </form>
                </div>
            </div>
            <div className="login-right">
                <img src={LoginImage} alt="login" />
            </div>
            {loginToast && <div className="login-toast-overlay">
                <div className="login-toast">
                    <p className="loginToastText" style={{ margin: 0 }}> Logged In Successfully</p>
                </div>
            </div>}
        </div>
    );
};

export default LoginPage;
